module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Wood#2-e715ff3a8a306d35de60338a31fed7fa.svg";